import { isURLScoped as f, setURLScope as y, getURLScope as l } from "@php-wasm/scopes";
const m = 25e3;
let R = 0;
function S(e, t, ...r) {
  const s = p();
  return e.postMessage(
    {
      ...t,
      requestId: s
    },
    ...r
  ), s;
}
function p() {
  return ++R;
}
function g(e, t, r = m) {
  return new Promise((s, c) => {
    const o = (a) => {
      a.data.type === "response" && a.data.requestId === t && (e.removeEventListener("message", o), clearTimeout(d), s(a.data.response));
    }, d = setTimeout(() => {
      c(new Error("Request timed out")), e.removeEventListener("message", o);
    }, r);
    e.addEventListener("message", o);
  });
}
function b(e, t) {
  return {
    type: "response",
    requestId: e,
    response: t
  };
}
async function U(e) {
  let t = new URL(e.request.url);
  if (!f(t))
    try {
      const n = new URL(e.request.referrer);
      t = y(t, l(n));
    } catch {
    }
  const r = e.request.headers.get("content-type"), s = e.request.method === "POST" ? new Uint8Array(await e.request.clone().arrayBuffer()) : void 0, c = {};
  for (const n of e.request.headers.entries())
    c[n[0]] = n[1];
  let o;
  try {
    const n = {
      method: "request",
      args: [
        {
          body: s,
          url: t.toString(),
          method: e.request.method,
          headers: {
            ...c,
            Host: t.host,
            // Safari and Firefox don't make the User-Agent header
            // available in the fetch event. Let's add it manually:
            "User-agent": self.navigator.userAgent,
            "Content-type": r
          }
        }
      ]
    }, i = l(t);
    if (i === null)
      throw new Error(
        `The URL ${t.toString()} is not scoped. This should not happen.`
      );
    const h = await w(n, i);
    o = await g(self, h), delete o.headers["x-frame-options"];
  } catch (n) {
    throw console.error(n, { url: t.toString() }), n;
  }
  if (o.httpStatusCode >= 300 && o.httpStatusCode <= 399 && o.headers.location)
    return Response.redirect(
      new URL(o.headers.location[0], t.toString()),
      o.httpStatusCode
    );
  const a = [101, 103, 204, 205, 304].includes(
    o.httpStatusCode
  ) ? null : o.bytes;
  return new Response(a, {
    headers: o.headers,
    status: o.httpStatusCode
  });
}
async function w(e, t) {
  const r = p();
  for (const s of await self.clients.matchAll({
    // Sometimes the client that triggered the current fetch()
    // event is considered uncontrolled in Google Chrome. This
    // only happens on the first few fetches() after the initial
    // registration of the service worker.
    includeUncontrolled: !0
  }))
    s.postMessage({
      ...e,
      /**
       * Attach the scope with a URL starting with `/scope:` to this message.
       *
       * We need this mechanics because this worker broadcasts
       * events to all the listeners across all browser tabs. Scopes
       * helps WASM workers ignore requests meant for other WASM workers.
       */
      scope: t,
      requestId: r
    });
  return r;
}
async function u(e, t) {
  const r = ["GET", "HEAD"].includes(e.method) || "body" in t ? void 0 : await e.blob();
  return new Request(t.url || e.url, {
    body: r,
    method: e.method,
    headers: e.headers,
    referrer: e.referrer,
    referrerPolicy: e.referrerPolicy,
    mode: e.mode === "navigate" ? "same-origin" : e.mode,
    credentials: e.credentials,
    cache: e.cache,
    redirect: e.redirect,
    integrity: e.integrity,
    ...t
  });
}
async function L(e) {
  if (!e.body)
    return [e, e];
  const [t, r] = e.body.tee();
  return [
    await u(e, { body: t, duplex: "half" }),
    await u(e, { body: r, duplex: "half" })
  ];
}
function T(e) {
  const t = {};
  return e.headers.forEach((r, s) => {
    t[s] = r;
  }), t;
}
export {
  g as awaitReply,
  w as broadcastMessageExpectReply,
  u as cloneRequest,
  U as convertFetchEventToPHPRequest,
  p as getNextRequestId,
  T as getRequestHeaders,
  S as postMessageExpectReply,
  b as responseTo,
  L as teeRequest
};
